// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for the span based on the changeInSqFt value */
.rfp_textUp__ywY6m {
  color: green;
  font-size: 12px; /* Adjust as needed */
  font-weight: bold;
}

.rfp_textDown__y8trX {
  color: red;
  font-size: 12px; /* Adjust as needed */
  font-weight: bold;
}

/* Additional styles for icons if needed */
.rfp_icon__gScY1 {
  font-size: 20px; /* Icon size */
  margin-right: 5px; /* Add spacing between icon and text */
}

.rfp_eyeIcon__jC0Fz {
  font-size: 20px;
  color: rgb(65, 140, 255);
}

.rfp_tableHead__Nj4oI {
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
}

.rfp_tableSubHead__wtb-\\+ {
  color: "black";
}

.rfp_tableRow__2SFqG {
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  /* width: 100px; */
  margin-left: 0.2rem;
}

.rfp_tableSubRow__BUSx3 {
  font-size: 12px;
  color: #6b7280;
}

/* Custom Scrollbar */
.rfp_custom-scrollbar__WYCqS::-webkit-scrollbar {
  width: 3px; /* Width of vertical scrollbar */
  height: 3px; /* Height of horizontal scrollbar */
}

/* Track */
.rfp_custom-scrollbar__WYCqS::-webkit-scrollbar-track {
  background: #f0f0f0; /* Light background */
  border-radius: 5px;
}

/* Handle */
.rfp_custom-scrollbar__WYCqS::-webkit-scrollbar-thumb {
  background: #999; /* Scrollbar color */
  border-radius: 4px;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
}

/* Handle on hover */
.rfp_custom-scrollbar__WYCqS::-webkit-scrollbar-thumb:hover {
  background: #666; /* Darker on hover */
}

/* Firefox scrollbar */
.rfp_custom-scrollbar__WYCqS {
  scrollbar-width: thin;
  scrollbar-color: #9c9f9f #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/RFPDashboard/RecceApproval/rfp.module.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,YAAY;EACZ,eAAe,EAAE,qBAAqB;EACtC,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe,EAAE,qBAAqB;EACtC,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,eAAe,EAAE,cAAc;EAC/B,iBAAiB,EAAE,sCAAsC;AAC3D;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,UAAU,EAAE,gCAAgC;EAC5C,WAAW,EAAE,mCAAmC;AAClD;;AAEA,UAAU;AACV;EACE,mBAAmB,EAAE,qBAAqB;EAC1C,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,gBAAgB,EAAE,oBAAoB;EACtC,kBAAkB;EAClB,+CAAuC;EAAvC,uCAAuC;AACzC;;AAEA,oBAAoB;AACpB;EACE,gBAAgB,EAAE,oBAAoB;AACxC;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,gCAAgC;AAClC","sourcesContent":["/* Styles for the span based on the changeInSqFt value */\n.textUp {\n  color: green;\n  font-size: 12px; /* Adjust as needed */\n  font-weight: bold;\n}\n\n.textDown {\n  color: red;\n  font-size: 12px; /* Adjust as needed */\n  font-weight: bold;\n}\n\n/* Additional styles for icons if needed */\n.icon {\n  font-size: 20px; /* Icon size */\n  margin-right: 5px; /* Add spacing between icon and text */\n}\n\n.eyeIcon {\n  font-size: 20px;\n  color: rgb(65, 140, 255);\n}\n\n.tableHead {\n  font-weight: 600;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.tableSubHead {\n  color: \"black\";\n}\n\n.tableRow {\n  font-size: 13px;\n  font-weight: 500;\n  color: #6b7280;\n  /* width: 100px; */\n  margin-left: 0.2rem;\n}\n\n.tableSubRow {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* Custom Scrollbar */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 3px; /* Width of vertical scrollbar */\n  height: 3px; /* Height of horizontal scrollbar */\n}\n\n/* Track */\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: #f0f0f0; /* Light background */\n  border-radius: 5px;\n}\n\n/* Handle */\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: #999; /* Scrollbar color */\n  border-radius: 4px;\n  transition: background 0.3s ease-in-out;\n}\n\n/* Handle on hover */\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #666; /* Darker on hover */\n}\n\n/* Firefox scrollbar */\n.custom-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: #9c9f9f #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textUp": `rfp_textUp__ywY6m`,
	"textDown": `rfp_textDown__y8trX`,
	"icon": `rfp_icon__gScY1`,
	"eyeIcon": `rfp_eyeIcon__jC0Fz`,
	"tableHead": `rfp_tableHead__Nj4oI`,
	"tableSubHead": `rfp_tableSubHead__wtb-+`,
	"tableRow": `rfp_tableRow__2SFqG`,
	"tableSubRow": `rfp_tableSubRow__BUSx3`,
	"custom-scrollbar": `rfp_custom-scrollbar__WYCqS`
};
export default ___CSS_LOADER_EXPORT___;
